import { render, staticRenderFns } from "./vHeader.vue?vue&type=template&id=46b35ce2&scoped=true"
import script from "./vHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./vHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vHeader.vue?vue&type=style&index=0&id=46b35ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b35ce2",
  null
  
)

export default component.exports